module.exports = __webpack_public_path__ + "img/header-engagementRingsUsa@2x.5253ec2.webp";